// https://vuex.vuejs.org/en/actions.html

import rolesService from '@/services/Admin/roleService'
import store from '@/store'

export default {
  async RefreshRoles (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading Roles')
    var apiResult = await rolesService.getAll()
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }
    context.commit('refreshRoles', apiResult.value)
    // load the dependencies

    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
